{
  "version": 1,
  "asset_id": "0fa86156-7fad-47b6-9bb8-172e3689c4d5",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0fa86156-7fad-47b6-9bb8-172e3689c4d5/texas-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0fa86156-7fad-47b6-9bb8-172e3689c4d5/texas-1280.webp",
  "original_filename": "texas-1280.webp",
  "size": 41666,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:05Z"
}
